import swal from "sweetalert";

export default (callback) => {
  swal({
    icon: "error",
    type: "error",
    title: "Your session got expired please login again",
  }).then(callback);
};
